// extracted by mini-css-extract-plugin
export var headerCell = "_3v-1";
export var loadingSpinnerContainer = "_3v-4";
export var rowWrapper = "_3v-3";
export var standaloneTable = "_3v-5";
export var table = "_3v-0";
export var white = "_3v-2";